import createStore from 'fluxible/addons/createStore';

type ContestUserRole = 'owner' | 'designer' | 'guest' | 'admin' | 'none';
type HalLinks = Record<string, { href: string }>;

interface HalJsonForUserAndContest {
    id: number;
    name: string;
    role: ContestUserRole;
    profileUrl: string;
    avatarUrl: string;
    isDesigner: boolean;
    localTime: string;
    flags: string[];
    avatars: {
        extraLarge: string;
    };

    _links: HalLinks;
    _embedded: {
        tokens: {
            create_comment: string;
            update_comment: string;
            report_design: string;
            mark_as_read_comment: string;
            mark_as_seen_design: string;
            _links: HalLinks;
        }[];
        permission: {
            listingId: number;
            userId: number;
            canSubmit: boolean;
            reasonCannotEnter:
                | 'no-enter-cannot-view'
                | 'no-enter-own'
                | 'no-enter-not-activate'
                | 'no-enter-exclusive'
                | 'no-enter-jimdo-exclusive'
                | 'no-enter-print-basics-exclusive'
                | 'no-enter-logo-product-packaging-exclusive'
                | 'no-enter-non-jimdo-exclusive'
                | 'no-enter-not-available-for-work'
                | 'no-enter-invite'
                | 'no-enter-closed'
                | 'no-enter-logged-out'
                | 'no-enter-eliminated'
                | 'no-enter-not-designer'
                | 'no-enter-ratelimit-exceeded'
                | 'no-enter-verification-required'
                | 'no-enter-user-penalized'
                | 'no-enter-not-approved'
                | null;
        };
    };
}

declare global {
    interface Window {
        activeUser: HalJsonForUserAndContest | null;
    }
}

const ContestsActiveUserStore = createStore({
    storeName: 'ContestsActiveUserStore',
    initialize: function () {
        this.activeUser = window.activeUser;
    },
    handlers: {},
});
export default ContestsActiveUserStore;



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/ContestsActiveUserStore.ts